import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { printFullInventory } from '../Api'

export default generateApiAction({
  baseType: Types.PRINT.FULL_INVENTORY,
  api: printFullInventory,
  responseType: RESPONSETYPE.FILE
})



// WEBPACK FOOTER //
// ./src/actions/print/PrintFullInventoryAction.js